import { PageLoading } from '@/components/page-loading'
import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import { Modal } from 'antd'
import { SignTitle, SvgIcon } from '@/components'

import GatewayCreate from '@/pages/gateway/create-task'
import GatewayTask from '@/pages/gateway/task-list'
import GatewayTaskDetail from '@/pages/gateway/task-detail'
import { t } from '@/i18n'

export const GatewayLayout = () => {
  const [isShow, setIsShow] = useState(false)

  const menuList = [
    {
      key: 'create',
      label: t('创建任务'),
      component: <GatewayCreate />,
    },
    {
      key: 'task',
      label: t('任务列表'),
      component: <GatewayTask />,
    },
    {
      key: 'task',
      label: t('任务详情'),
      component: <GatewayTaskDetail />,
      show: false,
      name: 'detail',
    },
  ]
  const onShow = () => {
    setIsShow(true)
  }

  const onHide = () => {
    setIsShow(false)
  }

  const rightSlot = (
    <div
      onClick={() => {
        onShow()
      }}
      className="description"
    >
      <SvgIcon name={'场景描述'} width={14} style={{ marginRight: '6px', height: 14 }} />
      <span>{t('场景描述')}</span>
    </div>
  )

  return (
    <>
      <ContentLayout menuList={menuList} rightSlot={rightSlot}>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </ContentLayout>
      <Modal
        title={<SignTitle show>{t('场景描述')}</SignTitle>}
        visible={isShow}
        onCancel={onHide}
        footer={null}
        centered
      >
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('可验证设备类型')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t('上网行为管理、安全DNS、防火墙、IDS（入侵检测系统）、IPS（入侵防护系统）')}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证原理')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t(
            '此场景通过客户端模拟后门木马等恶意程序，对外发起网络请求（后门上线、载荷下载等操作），以实时评估用户实网环境即时情报驱动威胁检测的能力。',
          )}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('使用说明')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span>{t('创建任务前需部署客户端。')} </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px  ' }}
            />

            <span>{t('情报协议覆盖支持：HTTP协议、HTTPS协议、DNS协议、TCP协议等多种类型。')}</span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t(
                '情报类型覆盖支持：钓鱼网站、公共矿池、私有矿池、C2地址、勒索软件、网络云盘等数十种场景。',
              )}
            </span>
          </div>
        </div>
      </Modal>
    </>
  )
}
